define('modules/accounts/status/products/landings/model',['require','exports','module','app','env','base/model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");

    var BaseModel = require("base/model");

    var Model = BaseModel.extend({
        url: function() {
            return Config.backendUrl + "/accounts/status-landings/"+this.get('groupId');
        },
        initialize: function() {
            this.initRequestEvents();
        }
    });

    module.exports = Model;
});

